import { render, staticRenderFns } from "./role-details.vue?vue&type=template&id=3e9f0b4b"
import script from "./role-details.vue?vue&type=script&lang=js"
export * from "./role-details.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports